<template>
    <div class="slider-container">
        <img :src="`/images/${ (!isNewVehicle && likedCars.find(e => e.mkt_vehicle_id == car.id)) || (isNewVehicle && likedCars.find(e => e.mkt_brand_new_vehicle_id == car.id)) ? 'liked-hearth.png' : 'disliked-hearth.png'}`" alt="" 
            class="wish-hearth" title="Guarda tus autos favoritos para comparar facilmente más tarde"
            @click="toggleLike($event, car.id)">
        <!-- SWIPER THUMBS GALLERY -->
        <swiper-media-component :mi_vanguardia_id="mi_vanguardia_id" @showmodalgallery="showModalGallery()" :cover="cover" :gallery="gallery" @updateCurrentSlide="currentSlide = $event"></swiper-media-component>
        <!-- MODAL GALLERY -->
        <transition name="fade">
            <modal-gallery-component :mi_vanguardia_id="mi_vanguardia_id" :cover="cover" :gallery="gallery" @close="modalGallery = false" :currentSlide="currentSlide" v-if="modalGallery"></modal-gallery-component>
        </transition>
        <a v-if="isNewVehicle && fileUrl != ''" :href="fileUrl" class="tx-20" target="_blank">
            <p class="text-center">

                Descarga aquí la ficha técnica de este auto
                <img src="/assets/images/pdf_icon.png" style="width: 50px;" />
            </p>
        </a>
    </div>
</template>

<script>
export default {
    props:{
        car:{
            type: String,
            required: true
        },
        cover:{
            type: String,
            required: true
        },
        gallery:{
            type: Array,
            required: true
        },
        mi_vanguardia_id: {
            type: Boolean,
            default: false
        },
        isNewVehicle: {
            type: Boolean,
            default: false
        },
        fileUrl: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.likedCars = JSON.parse(localStorage.getItem('likes')) ?? []
    },
    data() {
        return {
            currentSlide: 5,
            modalGallery: false,
            likedCars: []
        }
    },
    methods: {
        showModalGallery(){
            this.modalGallery = true;
        },
        toggleLike(event, id) {
            const $img = event.target
            const likes = JSON.parse(localStorage.getItem('likes')) ?? []
            const likesArrayWasFirstTimeCreated = (!localStorage.getItem('likes') || likes.length == 0) ? true : false;
            
            if(!likes.find(e => e.mkt_vehicle_id == id) && !likes.find(e => e.mkt_brand_new_vehicle_id == id)) {

                if(!this.isNewVehicle)
                    likes.push({
                        mkt_vehicle_id: id
                    })
                else
                    likes.push({
                        mkt_brand_new_vehicle_id: id
                    })
                $img.src = '/images/liked-hearth.png'
                
                if(likes.length > 0) { 
                    if(!this.isNewVehicle)
                        this.saveSingleLike({mkt_vehicle_id: id})
                    else
                        this.saveNewSingleLike({mkt_brand_new_vehicle_id: id})
                }

                if(likesArrayWasFirstTimeCreated) this.$emit('showSignUpModal')
            } 
            else {
                if(!this.isNewVehicle) this.deleteLike(id)
                else this.deleteNewLike(id)
                likes.splice(likes.indexOf(id), 1)
                $img.src = '/images/disliked-hearth.png'
            }

            localStorage.setItem('likes', JSON.stringify(likes))
        },
        async saveSingleLike(like) {
            try {
                await axios.post(`/save-like`, like);
            } catch (error) {
                console.error(error);
            }
        },
        async deleteLike(id) {
            try {
                await axios.delete(`/delete-like/${id}`);
            } catch (error) {
                console.error(error);
            }
        },
        async saveNewSingleLike(like) {
            try {
                await axios.post(`/save-new-like`, like);
            } catch (error) {
                console.error(error);
            }
        },
        async deleteNewLike(id) {
            try {
                await axios.delete(`/delete-new-like/${id}`);
            } catch (error) {
                console.error(error);
            }
        },
    }
}
</script>

<style scoped>

.slider-container {
    position: relative;
}
img.wish-hearth {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 1;
}
</style>

